import { Component } from 'react';
import { inject } from 'mobx-react';
import propTypes from 'prop-types';

import { ProductSelectorContainer } from '../../../ProductSelector/ProductSelectorContainer';

class _EditableConfiguration extends Component {
  
  handleConfigClick = (selector) => {
    const { uiStore, item } = this.props;

    uiStore.openProductSelector(item.codification, item.name, selector);
  }

  render() {
    const { item, labelsStore, uiStore } = this.props;

    const { selectorConfiguration } = uiStore;

    const selectConfig = uiStore.updatedSelectorConfig(selectorConfiguration);

    return <ProductSelectorContainer 
      selectorConfig={selectConfig}
      item={item}
      labelsStore={labelsStore}
      handleConfigClick={this.handleConfigClick}
    />;
  }
}

_EditableConfiguration.propTypes = {
  item: propTypes.shape({
    name: propTypes.string,
    backURL: propTypes.string,
    configurationMasterId: propTypes.string,
    codification: propTypes.string
  }).isRequired,
  labelsStore: propTypes.shape({
    editConfiguration: propTypes.string
  }).isRequired,
  uiStore: propTypes.shape({
    selectorConfiguration,
    openProductSelector: propTypes.func,
    updatedSelectorConfig: propTypes.func
  }).isRequired
};

export const EditableConfiguration = inject('labelsStore', 'uiStore')(_EditableConfiguration);
